import { useState } from 'react';
import { useLang } from '../i18n';
import { Btn } from '../design/ui';
import { tarikhMasaPapar } from '../utils/tarikhPapar';

// Flow Ultra JENIS 2 sahaja (Gmail ahli family): credit dah guna lawan had pelanggan.
// Jenis 1 (Lite LP) tiada credit — komponen ini tidak dipapar untuk mereka.
// Data: access.t2 { dahGuna, had, kreditPada } dari /customer/overview; "Segarkan" minta
// extension baca semula page Activity Google (SESAAT_FLOW_T2_KREDIT → flowPilotBridge).
function mintaKredit() {
    return new Promise((resolve, reject) => {
        const requestId = crypto.randomUUID();
        const clean = () => { clearTimeout(timer); window.removeEventListener('message', receive); };
        const receive = e => {
            if (e.source !== window || e.origin !== location.origin || e.data?.type !== 'SESAAT_FLOW_T2_KREDIT_RESULT' || e.data.requestId !== requestId) return;
            clean(); e.data.ok ? resolve(e.data) : reject(new Error(e.data.code || 'T2_GAGAL'));
        };
        const timer = setTimeout(() => { clean(); reject(new Error('EXTENSION_TIMEOUT')); }, 75000);
        window.addEventListener('message', receive);
        window.postMessage({ type: 'SESAAT_FLOW_T2_KREDIT', requestId }, location.origin);
    });
}
const nombor = v => (Number.isSafeInteger(v) && v >= 0 ? v : null);
const RALAT = { T2_GMAIL_TAK_SAMA: 'fc.t2.errGmail', T2_KREDIT_TIMEOUT: 'fc.t2.errTimeout', EXTENSION_TIMEOUT: 'fc.t2.errTimeout', T2_TERLALU_KERAP: 'fc.t2.errKerap' };

export default function FlowT2Kredit({ access }) {
    const { t, lang } = useLang();
    const [segar, setSegar] = useState(null);
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState('');
    if (access?.kind !== 'login') return null;

    const had = nombor(segar?.had ?? access.t2?.had);
    const guna = nombor(segar?.dahGuna ?? access.t2?.dahGuna);
    const pada = segar ? Date.now() : access.t2?.kreditPada;
    const peratus = had && guna !== null ? Math.min(100, Math.round((guna / had) * 100)) : 0;
    const nada = peratus >= 100 ? 'bad' : peratus >= 80 ? 'warn' : 'ok';
    const fmt = n => (n === null ? '—' : n.toLocaleString());
    // Tarikh akhir guna credit = endAt yang admin isi dalam borang Jenis 2 (flowT2_akses).
    // Nilai buruk / tiada → baris tidak dipapar (jangan tunjuk "Invalid Date" kepada pelanggan).
    const tamat = Number.isSafeInteger(access.t2?.endAt) && access.t2.endAt > 0 ? access.t2.endAt : null;
    const tarikhTamat = tamat && new Date(tamat).toLocaleDateString(lang === 'en' ? 'en-MY' : 'ms-MY', { day: 'numeric', month: 'short', year: 'numeric' });

    async function kemaskini() {
        setBusy(true); setErr('');
        try { setSegar(await mintaKredit()); }
        catch (e) { setErr(t(RALAT[e.message] || 'fc.t2.errGeneric')); }
        finally { setBusy(false); }
    }

    return <section className="fc-t2" aria-label={t('fc.t2.title')}>
        <div className="fc-t2-head">
            <h2>{t('fc.t2.title')}</h2>
            <Btn variant="ghost" disabled={busy} onClick={kemaskini}>{busy ? t('fc.t2.refreshing') : t('fc.t2.refresh')}</Btn>
        </div>
        <p className="fc-t2-angka"><strong>~{fmt(guna)}</strong> / {fmt(had)} {t('fc.t2.credits')}</p>
        <div className={`fc-t2-bar fc-t2-bar--${nada}`} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={peratus}>
            <span style={{ width: peratus + '%' }} />
        </div>
        {guna !== null && had !== null && peratus >= 100 && <p className="fc-state fc-state--bad"><span className="fc-state-dot" aria-hidden="true" />{t('fc.t2.full')}</p>}
        {guna !== null && had !== null && peratus >= 80 && peratus < 100 && <p className="fc-state fc-state--warn"><span className="fc-state-dot" aria-hidden="true" />{t('fc.t2.near')}</p>}
        {tarikhTamat && <p className="fc-t2-tamat">{t('fc.t2.useBefore', { date: tarikhTamat })}</p>}
        <p className="fc-muted">{t('fc.t2.estimateNote')}</p>
        <p className="fc-muted">{pada ? t('fc.t2.updated') + ': ' + tarikhMasaPapar(pada, lang) : t('fc.t2.never')}</p>
        {err && <p className="fc-error" role="alert">{err}</p>}
    </section>;
}
